import {uploadFile} from './fileUtils'

export const compareObject = (obj1: Record<string, any>, obj2: Record<string, any>) => {
  const valuesCopy = Object.keys(obj1).reduce((acc: any, key) => {
    if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
      acc[key] = obj1[key]
    }
    return acc
  }, {})
  return valuesCopy
}
export async function getObjectDifferences(
  model: string,
  obj1: Record<string, any>,
  obj2?: Record<string, any>
): Promise<Record<string, any>> {
  const diff: Record<string, any> = {}
  // if (!obj2) return obj1
  for (const key in obj1) {
    if (obj1[key] instanceof File) {
      const uploaded = await uploadFile(obj1[key], model)
      obj1[key] = uploaded
    }
    if (Array.isArray(obj1[key])) {
      const res: any[] = []
      for (let idx = 0; idx < obj1[key].length; idx++) {
        const item = obj1[key][idx]
        const nestedDiff = await getObjectDifferences(model, item, obj2?.[key]?.[idx])
        if (Object.keys(nestedDiff).length > 0) res.push(nestedDiff)
      }
      if (res.length > 0) diff[key] = res
    } else if (obj2 && !(key in obj2)) {
      diff[key] = obj1[key] // key not in obj2
    } else if (typeof obj1[key] === 'object' && obj1[key] !== null) {
      const nestedDiff = await getObjectDifferences(model, obj1[key], obj2?.[key])
      if (Object.keys(nestedDiff).length > 0) {
        // let res = structuredClone(nestedDiff)
        // if (Array.isArray(obj1[key])) res = Object.values(res).filter((k) => !!k)
        diff[key] = nestedDiff
      }
    } else if (obj1[key] !== obj2?.[key]) {
      diff[key] = obj1[key] // value differs
    }
  }
  if (Object.keys(diff).length > 0) diff.id = obj1.id || obj2?.id
  if (!diff.id) delete diff.id
  return diff
}
